module.exports = __webpack_public_path__ + "static/img/rightLogo.b45a53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/rightLogo.png
// module id = 5TcV
// module chunks = 0